<template>
  <form>
    <div class="search-wrap">
      <!--      <button type="button" @click="getStore()"> Store Test</button>-->
      <!-- Hab hier input und label vertauscht...laut Internet muss das so es geht aber nicht..Anzeigefehler     -->
      <div class="radio-wrapper">
        <input type="radio" id="radio-long" name="radio" v-model="longfilm" :value="true">
        <label class="radio-select" for="radio-long">All festivals</label><br>
        <input type="radio" id="radio-short" name="radio" v-model="longfilm" :value="false">
        <label class="radio-select" for="radio-short">Short film festivals</label>
      </div>
      <input id="international-comp" type="checkbox" v-model="internationalCompetition">
      <label for="international-comp" class="search-criteria plus-padding">International competition</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="festivalTitle" >
      <label class="search-criteria">Title</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="festivalCity">
      <label class="search-criteria">City</label>
      <label class="search-criteria space-top">Country</label>
      <select class="custom-select no-space-bottom" v-model="festivalCountry">
        <option :value="0" selected>Please Select</option>
        <option v-for="country in this.$store.state.countries" :key="country.uid" :value="country.uid">{{ country.cn_short_en }}</option>
      </select>
      <div v-if="!this.longfilm">
        <div class="flex">
          <select class="custom-select no-space-bottom thin-select" v-model="lengthCategory">
            <option :value="''" selected>Please Select</option>
            <option :value="'length_fiction'">Fiction</option>
            <option :value="'length_animation'">Animation</option>
            <option :value="'length_experimental'">Experimental</option>
            <option :value="'length_documentary'">Documentary</option>
          </select>
          <input v-model="this.lengthInMinutes" v-on:keyup.enter="this.search" type="number" class="form-control length-search">
        </div>

        <label class="search-criteria">Length in minutes</label>
      </div>

      <div class="genre">
        <div class="extend-searchbar" @click="this.extendGenres">
          <label class="search-criteria" >Genre</label>
          <span id="filmgenre" class="icon-plus_im_kreis"/>
        </div>
        <div class="form-group">
          <div id="genre-box" class="checkbox-container">
            <div v-for="genre in this.$store.state.allGenres" :key="genre.uid">
              <input type="checkbox" :id="'gen'+genre.uid" :value="genre.uid" v-model="checkedGenre">
              <label :for="'gen'+genre.uid"> {{ genre.title }}</label><br>
            </div>
<!--            <span @click="this.extendGenres" class="icon-x_im_kreis"/>-->
          </div>
        </div>
      </div>
      <div class="category">
        <div class="extend-searchbar" @click="this.extendCategories">
          <label class="search-criteria">Category</label>
          <span id="filmcategory" class="icon-plus_im_kreis"/>
        </div>
        <div class="form-group">
          <div id="category-box" class="checkbox-container">
            <div v-for="category in this.$store.state.allCategories" :key="category.uid">
              <input type="checkbox" :id="'cat'+category.uid" :value="category.uid"
                     v-model="checkedCategory">
              <label :for="'cat'+category.uid"> {{ category.title }}</label><br>
            </div>
<!--            <span @click="this.extendCategories" class="icon-x_im_kreis"/>-->
          </div>
        </div>
      </div>
      <div v-if="!this.longfilm">
        <div class="category">
        <div class="extend-searchbar" @click="this.extendCharacteristics()">
          <label class="search-criteria">Specific characteristics</label>
          <span id="specific-characteristics" class="icon-plus_im_kreis"/>
        </div>
        <div class="form-group">
          <div id="characteristics-box" class="checkbox-container">
            <div>
              <input type="checkbox" id="oscar_action_animation_short" value="1" v-model="checkedCharacteristics">
              <label for="oscar_action_animation_short"> {{ this.$store.state.texts.oscar_action_animation_short }}</label><br>
            </div>
            <div>
              <input type="checkbox" id="oscar_documentary" value="2" v-model="checkedCharacteristics">
              <label for="oscar_documentary"> {{ this.$store.state.texts.oscar_documentary }}</label><br>
            </div>
            <div>
              <input type="checkbox" id="student_aaq" value="3" v-model="checkedCharacteristics">
              <label for="student_aaq"> {{ this.$store.state.texts.student_aaq }}</label><br>
            </div>
            <div>
              <input type="checkbox" id="melies_award_quali" value="4" v-model="checkedCharacteristics">
              <label for="melies_award_quali"> {{ this.$store.state.texts.melies_award_quali }}</label><br>
            </div>
            <div>
              <input type="checkbox" id="ffa_short_film_fund" value="5" v-model="checkedCharacteristics">
              <label for="ffa_short_film_fund"> {{ this.$store.state.texts.ffa_short_film_fund }}</label><br>
            </div>
            <div>
              <input type="checkbox" id="member_ag_kurzfilm" value="6" v-model="checkedCharacteristics">
              <label for="member_ag_kurzfilm"> {{ this.$store.state.texts.member_ag_kurzfilm }}</label><br>
            </div>
            <div>
              <input type="checkbox" id="specific_oscarqualify" value="7" v-model="checkedCharacteristics">
              <label for="specific_oscarqualify"> {{ this.$store.state.texts.specific_oscarqualify }}</label><br>
            </div>
            <div>
              <input type="checkbox" id="specific_efa" value="8" v-model="checkedCharacteristics">
              <label for="specific_efa"> {{ this.$store.state.texts.specific_efa }}</label><br>
            </div>
          </div>
        </div>
      </div>
      </div>
      <label class="search-criteria datepicker-title">Event date</label>
      <div class="wrap-datepicker" >
        <datepicker :lang="'en'" v-model="eventDate"></datepicker><span class="clearDatepicker icon-x_im_kreis " @click="this.resetEventDate"/>
      </div>
      <label class="search-criteria datepicker-title">Registration deadline</label>
      <div class="wrap-datepicker">
        <datepicker :lang="'en'" v-model="registrationDeadline"></datepicker><span class="clearDatepicker icon-x_im_kreis" @click="this.resetDeadline"/>
      </div>
      <div v-if="!this.longfilm">
        <label class="search-criteria datepicker-title">Finished in</label>
        <div class="wrap-datepicker">
          <datepicker :lang="'en'" v-model="finished"></datepicker><span class="clearDatepicker icon-x_im_kreis" @click="this.resetFinished"/>
        </div>
      </div>
      <div >
        <label class="search-criteria">Type of festival</label>
        <select class="custom-select" id="exampleFormControlSelect1" v-model="typeOfFestival">
          <option value="0" selected>Please select</option>
          <option v-for="type in this.$store.state.festivalTypes"  :key="type.uid" :value="type.uid">{{ type.title }}</option>
        </select>
      </div>
      <label class="search-criteria">Premiere requirement</label>
      <select class="custom-select" v-model="premiereRequirement">
        <option value="0" selected>Please select</option>
        <option value="1">{{ this.$store.state.texts.premiere_requirement_1 }}</option>
        <option value="2">{{ this.$store.state.texts.premiere_requirement_2 }}</option>
        <option value="3">{{ this.$store.state.texts.premiere_requirement_3 }}</option>
      </select>
      <div class="searchbar-footerline">
        <div id="searchbar-buttons" @click="this.search">
          <span class="link-arrow">Search</span>
        </div>
      </div>
    </div>
  </form>
  <div class="download-box-wrapper">
    <div class="download-box">
      <span class="btn btn-primary" v-if="!loadingDownload" @click="this.download()">Download matching festivals</span>
      <svg v-else id="download-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" xml:space="preserve">
      <path fill="#ff0000" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
        <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            dur="1s"
            from="0 50 50"
            to="360 50 50"
            repeatCount="indefinite"/>
      </path>
    </svg>
    </div>
  </div>
</template>
<script>
import VueDatepickerUi from 'vue-datepicker-ui';

export default {
  data() {
    return {
      hostname: this.$store.state.hostname,
      prefix: `${this.$store.state.extensionName}_${this.$store.state.pluginName}`,
      type: this.$store.state.type,
      longfilm: true,
      premiereRequirement: 0,
      checkedCharacteristics: [],
      lengthInMinutes: null,
      lengthCategory: null,
      loadingDownload: false,
      festivalTitle: '',
      festivalCountry: 0,
      festivalCity: '',
      checkedCategory: [],
      checkedGenre: [],
      registrationDeadline: null,
      typeOfFestival: 0,
      internationalCompetition: false,
      eventDate: null,
      finished: null,
      countIncrease: 10,
      festivalId: 0,
    };
  },
  components: {
    Datepicker: VueDatepickerUi,
  },
  methods: {
    async fetchOldestFilm() {
      // Datum des ältesten Films wird für den niedrigsten möglichen Wert des Sliders benötigt
      // Genres und Kategorien für die Checkboxen werden Dynamisch aus den Ergebnissen dieses Fetches aufgelistet
      await fetch(
        `https://${this.hostname}/?&${this.prefix}[filter][answerType]=initial&type=${this.type}'`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          await this.$store.commit('updateAllGenres', data.genre);
          await this.$store.commit('updateAllCategories', data.category);
          await this.$store.commit('updateFestivalTypes', data.types);
          await this.$store.commit('updateCoutries', data.countries);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    extendCategories() {
      // Methode um Kategorien auszuklappen
      const categoryBox = document.getElementById('category-box');
      const categoryIcon = document.getElementById('filmcategory');
      const genreBox = document.getElementById('genre-box');
      const genreIcon = document.getElementById('filmgenre');
      if (!this.longfilm) {
        const characteristicsBox = document.getElementById('characteristics-box');
        const characteristicsIcon = document.getElementById('specific-characteristics');
        if (characteristicsBox.classList.contains('extend-checkboxes')) {
          characteristicsBox.classList.remove('extend-checkboxes');
          characteristicsIcon.classList.remove('icon-minus_im_kreis');
          characteristicsIcon.classList.add('icon-plus_im_kreis');
        }
      }
      // Methode um Genres auszuklappen
      if (genreBox.classList.contains('extend-checkboxes')) {
        genreBox.classList.remove('extend-checkboxes');
        genreIcon.classList.remove('icon-minus_im_kreis');
        genreIcon.classList.add('icon-plus_im_kreis');
      }
      if (categoryBox.classList.contains('extend-checkboxes')) {
        categoryBox.classList.remove('extend-checkboxes');
        categoryIcon.classList.remove('icon-minus_im_kreis');
        categoryIcon.classList.add('icon-plus_im_kreis');
        return;
      }
      categoryBox.classList.add('extend-checkboxes');
      categoryIcon.classList.remove('icon-plus_im_kreis');
      categoryIcon.classList.add('icon-minus_im_kreis');
    },
    extendGenres() {
      const categoryBox = document.getElementById('category-box');
      const categoryIcon = document.getElementById('filmcategory');
      const genreBox = document.getElementById('genre-box');
      const genreIcon = document.getElementById('filmgenre');
      if (!this.longfilm) {
        const characteristicsBox = document.getElementById('characteristics-box');
        const characteristicsIcon = document.getElementById('specific-characteristics');
        if (characteristicsBox.classList.contains('extend-checkboxes')) {
          characteristicsBox.classList.remove('extend-checkboxes');
          characteristicsIcon.classList.remove('icon-minus_im_kreis');
          characteristicsIcon.classList.add('icon-plus_im_kreis');
        }
      }
      // Methode um Genres auszuklappen
      if (categoryBox.classList.contains('extend-checkboxes')) {
        categoryBox.classList.remove('extend-checkboxes');
        categoryIcon.classList.remove('icon-minus_im_kreis');
        categoryIcon.classList.add('icon-plus_im_kreis');
      }
      if (genreBox.classList.contains('extend-checkboxes')) {
        genreBox.classList.remove('extend-checkboxes');
        genreIcon.classList.remove('icon-minus_im_kreis');
        genreIcon.classList.add('icon-plus_im_kreis');
        return;
      }
      genreBox.classList.add('extend-checkboxes');
      genreIcon.classList.remove('icon-plus_im_kreis');
      genreIcon.classList.add('icon-minus_im_kreis');
    },
    extendCharacteristics() {
      const categoryBox = document.getElementById('category-box');
      const categoryIcon = document.getElementById('filmcategory');
      const genreBox = document.getElementById('genre-box');
      const genreIcon = document.getElementById('filmgenre');
      const characteristicsBox = document.getElementById('characteristics-box');
      const characteristicsIcon = document.getElementById('specific-characteristics');
      // Methode um Genres auszuklappen
      if (categoryBox.classList.contains('extend-checkboxes')) {
        categoryBox.classList.remove('extend-checkboxes');
        categoryIcon.classList.remove('icon-minus_im_kreis');
        categoryIcon.classList.add('icon-plus_im_kreis');
      }
      if (genreBox.classList.contains('extend-checkboxes')) {
        genreBox.classList.remove('extend-checkboxes');
        genreIcon.classList.remove('icon-minus_im_kreis');
        genreIcon.classList.add('icon-plus_im_kreis');
      }
      if (characteristicsBox.classList.contains('extend-checkboxes')) {
        characteristicsBox.classList.remove('extend-checkboxes');
        characteristicsIcon.classList.remove('icon-minus_im_kreis');
        characteristicsIcon.classList.add('icon-plus_im_kreis');
        return;
      }
      characteristicsBox.classList.add('extend-checkboxes');
      characteristicsIcon.classList.remove('icon-plus_im_kreis');
      characteristicsIcon.classList.add('icon-minus_im_kreis');
    },
    async search() {
      // Wird aufgerufen beim Suchen
      this.$store.commit('completeLoading', false);
      if (this.festivalId === 0) {
        await this.$store.commit('clearEntries');
      }
      await this.$store.commit('updateError', 0);
      await this.$store.commit('updateCounter', 0);
      await this.fetchIdArray();
      if (await this.nextItems()) {
        await this.fetchItems();
      }
      if (this.festivalId === 0) {
        await this.$router.push({ path: this.$store.state.site, query: await this.buildVueURL() });
      } else {
        this.festivalId = 0;
      }
      await this.$store.commit('completeLoading', true);
    },
    checkUserInput() {
      // Überprüft ob der Benutzer nicht zulässige Zeichen in die Text-Suchfelder eingetragen hat
      this.festivalTitle = this.festivalTitle.replace(/[^a-zA-Z0-9\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.festivalCity = this.festivalCity.replace(/[^a-zA-Z\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
    },
    async fetchItems() {
      await fetch(
        `https://${this.hostname}/?&${this.prefix}[filter][answerType]=items&${this.prefix}[items]=${await this.nextItems()}&type=${this.type}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          await this.$store.commit('updateWholeDatabase', data.itemList);
          await this.$store.commit('updateTexts', data.text);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    async fetchIdArray() {
      // Fordert ein Array mit IDs von Filmen an, die zu den eingegebenen Suchkriterien passen
      await fetch(
        await this.buildControllerURL(),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          await this.$store.commit('updateIdForSearchRequest', data.matchingIDs);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    async nextItems() {
      // Hilfsfunktion von fetchItems()
      // Sucht die nächsten filmIDs raus
      if (this.$store.state.idForSearchRequest.length === 0) {
        return null;
      }
      const tempArray = [];
      for (let i = 0; i < this.countIncrease; i += 1) {
        if (this.$store.state.idForSearchRequest[this.$store.state.counter + i] != null) {
          tempArray.push(this.$store.state.idForSearchRequest[this.$store.state.counter + i]);
        }
      }
      return tempArray;
    },
    async buildControllerURL() {
      // Baut eine URL zusammen mit der die Suchparameter an den Filmcontroller übergeben werden
      let URLParams = `https://${this.hostname}/?&`;
      if (this.checkedGenre.length > 0) {
        URLParams += `${this.prefix}[filter][genre]=${this.checkedGenre}&`;
      }
      if (this.checkedCategory.length > 0) {
        URLParams += `${this.prefix}[filter][category]=${this.checkedCategory}&`;
      }
      if (this.festivalTitle !== '') {
        URLParams += `${this.prefix}[filter][festivalTitle]=${this.festivalTitle}&`;
      }
      if (this.festivalCity !== '') {
        URLParams += `${this.prefix}[filter][festivalCity]=${this.festivalCity}&`;
      }
      if (this.festivalCountry !== 0) {
        URLParams += `${this.prefix}[filter][festivalCountry]=${this.festivalCountry}&`;
      }
      if (this.internationalCompetition === true) {
        URLParams += `${this.prefix}[filter][internationalCompetition]=1&`;
      }
      if (this.eventDate) {
        // eslint-disable-next-line
        URLParams += `${this.prefix}[filter][eventDate]=${parseInt(this.eventDate.getTime() / 1000).toFixed(0)}&`;
      }
      if (this.registrationDeadline) {
        // eslint-disable-next-line
        URLParams += `${this.prefix}[filter][registrationDeadline]=${parseInt(this.registrationDeadline.getTime() / 1000).toFixed(0)}&`;
      }
      if (this.finished) {
        // eslint-disable-next-line
        URLParams += `${this.prefix}[filter][finished]=${parseInt(this.finished.getTime() / 1000).toFixed(0)}&`;
      }
      if (this.typeOfFestival > 0) {
        URLParams += `${this.prefix}[filter][typeOfFestival]=${this.typeOfFestival}&`;
      }
      if (this.lengthInMinutes && this.lengthCategory) {
        URLParams += `${this.prefix}[filter][lengthInMinutes]=${this.lengthInMinutes}&`;
        URLParams += `${this.prefix}[filter][lengthCategory]=${this.lengthCategory}&`;
      }
      if (this.checkedCharacteristics.length > 0) {
        URLParams += `${this.prefix}[filter][characteristics]=${this.checkedCharacteristics}&`;
      }
      if (this.premiereRequirement > 0) {
        URLParams += `${this.prefix}[filter][premiereRequirement]=${this.premiereRequirement}&`;
      }
      URLParams += `${this.prefix}[filter][sortCriteria]=${this.$store.state.sortCriteria}&`;
      URLParams += `${this.prefix}[filter][answerType]=IDs&`;
      URLParams += `type=${this.type}`;
      this.$store.commit('updateURL', URLParams);
      return URLParams;
    },
    async buildVueURL() {
      const URLParams = [];
      if (this.checkedGenre.length > 0) {
        URLParams.checkedGenre = this.checkedGenre.toString();
      }
      if (this.checkedCategory.length > 0) {
        URLParams.checkedCategory = this.checkedCategory.toString();
      }
      if (this.festivalTitle !== '') {
        URLParams.festivalTitle = this.festivalTitle;
      }
      if (this.festivalCountry !== 0) {
        URLParams.festivalCountry = this.festivalCountry;
      }
      if (this.festivalCity !== '') {
        URLParams.festivalCity = this.festivalCity;
      }
      if (this.internationalCompetition === true) {
        URLParams.internationalCompetition = this.internationalCompetition;
      }
      if (this.eventDate) {
        // eslint-disable-next-line
        URLParams.eventDate = parseInt(this.eventDate.getTime() / 1000).toFixed(0);
      }
      if (this.registrationDeadline) {
        // eslint-disable-next-line
        URLParams.registrationDeadline = parseInt(this.registrationDeadline.getTime() / 1000).toFixed(0);
      }
      if (this.finished) {
        // eslint-disable-next-line
        URLParams.finished = parseInt(this.finished.getTime() / 1000).toFixed(0);
      }
      if (this.typeOfFestival > 0) {
        URLParams.typeOfFestival = this.typeOfFestival;
      }
      if (this.lengthInMinutes && this.lengthCategory) {
        URLParams.lengthInMinutes = this.lengthInMinutes;
        URLParams.lengthCategory = this.lengthCategory;
      }
      if (this.checkedCharacteristics.length > 0) {
        URLParams.checkedCharacteristics = this.checkedCharacteristics.toString();
      }
      if (this.premiereRequirement > 0) {
        URLParams.premiereRequirement = this.premiereRequirement;
      }
      URLParams.sortCriteria = this.$store.state.sortCriteria;
      await this.$store.commit('updateVueURL', URLParams);
      return URLParams;
    },
    async readVueURL() {
      if (this.$route.query.show) {
        const regExp = /[a-zA-Z]/g;
        if (regExp.test(this.$route.query.show)) {
          window.location.href = '/404';
        } else {
          // eslint-disable-next-line radix
          this.festivalId = parseInt(this.$route.query.show);
        }
        return;
      }
      if (this.$route.query.checkedGenre) {
        this.checkedGenre = this.$route.query.checkedGenre.split(',');
      }
      if (this.$route.query.checkedCategory) {
        this.checkedCategory = this.$route.query.checkedCategory.split(',');
      }
      if (this.$route.query.calendar === 'true') {
        this.eventDate = new Date(new Date().getFullYear(), 0, 1);
        this.$store.commit('updateSortCriteria', 'event_date_start,asc');
      }
      if (this.$route.query.festivalTitle) {
        this.festivalTitle = this.$route.query.festivalTitle;
      }
      if (this.$route.query.festivalCity) {
        this.festivalCity = this.$route.query.festivalCity;
      }
      if (this.$route.query.festivalCountry) {
        this.festivalCountry = parseInt(this.$route.query.festivalCountry, 10);
      }
      if (this.$route.query.internationalCompetition === 'true') {
        this.internationalCompetition = true;
      }
      if (this.$route.query.sortCriteria) {
        this.$store.commit('updateSortCriteria', this.$route.query.sortCriteria);
      }
      if (this.$route.query.eventDate) {
        this.eventDate = new Date(this.$route.query.eventDate * 1000);
      }
      if (this.$route.query.registrationDeadline) {
        this.registrationDeadline = new Date(this.$route.query.registrationDeadline * 1000);
      }
      if (this.$route.query.finished) {
        this.finished = new Date(this.$route.query.finished * 1000);
      }
      if (this.$route.query.typeOfFestival) {
        this.typeOfFestival = this.$route.query.typeOfFestival;
      }
      if (this.$route.query.lengthInMinutes) {
        this.lengthInMinutes = this.$route.query.lengthInMinutes;
      }
      if (this.$route.query.lengthCategory) {
        this.lengthCategory = this.$route.query.lengthCategory;
      }
      if (this.$route.query.checkedCharacteristics) {
        this.checkedCharacteristics = this.$route.query.checkedCharacteristics.split(',');
      }
      if (this.$route.query.premiereRequirement) {
        this.premiereRequirement = this.$route.query.premiereRequirement;
      }
    },
    async showModal() {
      if (this.festivalId !== 0) {
        await fetch(
          `https://${this.hostname}/?&${this.prefix}[filter][answerType]=items&${this.prefix}[items]=${this.festivalId}&type=${this.type}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          },
        )
          .then((response) => response.json())
          .then(async (data) => {
            if (data.itemList[0].uid) {
              await this.$store.commit('updateWholeDatabase', data.itemList);
              await this.$store.commit('updateSelectedFestivalCard', this.festivalId);
            } else {
              window.location.href = '/404';
            }
          }).catch(() => {
            this.$store.commit('completeLoading', true);
            this.$store.commit('updateError', 1);
          });
      }
    },
    async resetEventDate() {
      this.eventDate = null;
    },
    async resetDeadline() {
      this.registrationDeadline = null;
    },
    async resetFinished() {
      this.finished = null;
    },
    async fetchForDownload() {
      let items = null;
      await fetch(
        `https://${this.hostname}/?&${this.prefix}[filter][answerType]=export&${this.prefix}[items]=${this.$store.state.idForSearchRequest}&type=${this.type}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          items = data.itemList;
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
      return items;
    },
    async download() {
      this.loadingDownload = true;
      const items = await this.fetchForDownload();
      const fileName = `${(new Date().toLocaleDateString('de-GE')).replaceAll('.', '_')}_Festivals.csv`;
      // eslint-disable-next-line
      for (let i in items){
        items[i].event_date_start = new Date(items[i].event_date_start * 1000).toLocaleDateString('de-GE');
        items[i].registration_deadline = (items[i].registration_deadline !== 0) ? (new Date(items[i].registration_deadline * 1000).toLocaleDateString('de-GE')) : '';
        items[i].early_deadline = (items[i].early_deadline !== 0) ? (new Date(items[i].early_deadline * 1000).toLocaleDateString('de-GE')) : '';
        items[i].late_deadline = (items[i].late_deadline !== 0) ? (new Date(items[i].late_deadline * 1000).toLocaleDateString('de-GE')) : '';
        items[i].event_date_end = new Date(items[i].event_date_end * 1000).toLocaleDateString('de-GE');
      }
      const arrData = items;
      let CSV = '';
      // Header -Zeile
      let row = '';
      // eslint-disable-next-line
      Object.keys(arrData[0]).forEach((key) => row += `${key};`);
      row = row.slice(0, -1);
      CSV += `${row}\r\n`;
      arrData.forEach((item) => {
        row = '';
        // eslint-disable-next-line
        Object.values(item).forEach((string) => row += (string) ? `${(string).replaceAll(';', ',')};` : ';');
        row = row.slice(0, row.length - 1);
        CSV += `${row.replaceAll('\r\n', ',')}\r\n`;
      });

      if (CSV === '') {
        alert('Invalid data');
        return;
      }

      CSV = `\uFEFF${CSV}`;

      const uri = `data:text/csv;charset=utf-8,${encodeURIComponent(CSV)}`;
      const link = document.createElement('a');
      link.href = uri;
      link.style = 'visibility:hidden';
      link.download = fileName;

      document.body.appendChild(link);
      this.loadingDownload = false;
      link.click();
      document.body.removeChild(link);
    },
  },
  updated() {
    this.checkUserInput();
  },
  async created() {
    const head = document.getElementsByTagName('HEAD')[0];
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `https://${this.hostname}/typo3conf/ext/sn_movie_festival_db/Resources/Public/Css/festivalStyles.css`;
    head.appendChild(link);
    await this.fetchOldestFilm();
    await this.$store.commit('updateSite', this.$route.fullPath);
    await this.readVueURL();
    await this.showModal();
    await this.search();
    this.$watch('$store.state.sortCriteria', async function () {
      await this.search();
    });
  },
  watch: {
    '$store.state.counter': async function () {
      await this.fetchItems();
    },
    longfilm() {
      if (this.longfilm === true) {
        if (this.checkedGenre.includes(52) || this.checkedGenre.includes('52')) {
          // eslint-disable-next-line
          this.checkedGenre = this.checkedGenre.filter((value) => {
            // eslint-disable-next-line
            return value != 52;
          });
        }
      } else if (!this.checkedGenre.includes(52) && !this.checkedGenre.includes('52')) {
        this.checkedGenre.push(52);
      }
    },
    checkedGenre() {
      this.longfilm = !(this.checkedGenre.includes(52) || this.checkedGenre.includes('52'));
    },
  },
};
</script>

<style>
.flex{
  display: flex;
}
.flex .length-search{
  width: 4rem;
  margin-left: 15px;
}

.flex .thin-select{
  margin-top: 2rem;
}
.search-criteria.datepicker-title{
  font-size: 1rem;
  line-height: 1rem;
}

input[type=radio]{
  display: none;
}

input[type=radio] + label::before {
  padding-right: 5px;
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e90f";
}

input[type=radio]:checked+label::before {
  content: "\e910";
}

.radio-select{
  font-weight: 700;
  margin: 0;
  color: #3c3c3c;
}

.download-box-wrapper{
  background-color: #ebebeb;
  width: 100%;
  height: 9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.download-box{
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

#download-svg{
  padding-left: 1rem;
  height: 5rem;
}

.search-wrap .custom-select {
  margin-bottom: 1rem;
  border: 1px solid #3c3c3c;
  color: #3c3c3c;
  --panel-background: #3c3c3c !important;
  --arrowpanel-background: #3c3c3c !important;
  background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 27 27'%3e%3cpolygon fill='black' points='20.8,9.9 13.8,17 6.7,9.9 4.9,11.7 13.8,20.5 22.6,11.7 '/%3e%3c/svg%3e") no-repeat right 0.75rem center/30px 30px;
}

.search-wrap .custom-select option{
  color: #3c3c3c;
}

.custom-select option{
  font-family: 'Avenir Next Pro',serif, Arial ;
}

.clearDatepicker{
  font-size: 1.6rem;
  height: fit-content;
  color: #3c3c3c;
}

.radio-wrapper{
  margin-bottom: 1rem;
}

.radio-select{
  margin: 5px 0;
}

.search-wrap .search-criteria.plus-padding{
  font-size: 1rem;
  line-height: 1rem;
  padding: 1rem 0;
}

.wrap-datepicker{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.range-slider {
  width: 300px;
  margin: auto;
  position: relative;
  height: 3rem;
}
.slider{
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: 0;
  pointer-events: none;
  position: absolute;
  left: 0;
  bottom: 0;
  /* als alternative ausblenden? */
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.slider:focus {
  outline: none;
}
.slider::-webkit-slider-runnable-track {
  outline: 0;
  -webkit-appearance: none;
  background: #3c3c3c;
  width: 100%;
  height: 5px;
  cursor: pointer;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: auto;
  z-index: 2;
  position: relative;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #ffffff;
  cursor: pointer;
  margin-top: -7px;
}
.slider::-moz-range-track {
  cursor: default;
  -moz-appearance: none;
  outline: 0;
  height: 5px;
  background: #3c3c3c;
}
.slider::-moz-range-thumb {
  z-index: 2;
  -moz-appearance: none;
  pointer-events: auto;
}
/* Funktion muss überprüft werden */
.slider::-ms-track{
  height: 5px;
  background: #3c3c3c;
}
.slider::-ms-thumb{
  z-index: 2;
  pointer-events: auto;
}

#end-date-slider.slider::-moz-range-track{
  background: transparent;
/*  Das muss so; sonst sieht der Slider im Firefox seltsam aus*/
}

#filmcategory, #filmgenre, #specific-characteristics{
  font-size: 1.6rem;
  color: #3c3c3c;
}

.space-top{
  margin-top: 2rem !important;
}

.no-space-bottom{
  margin-bottom: 0 !important;
}

/* Datepicker CSS */
:root {
  --v-calendar-picker-color: #fff;
  --v-calendar-input-bg-color: #fff;
  --v-calendar-input-bg-disable-color: #f5f5f5;
  --v-calendar-input-text-disable-color: #b8b8b9;
  --v-calendar-select-bg-color: #fff;
  --v-calendar-border-color: #eaeaeb;
  --v-calendar-triangle-color: #eaeaeb;
  --v-calendar-shadow: 0 20px 30px 0 rgba(0, 0, 0, .2);
  --v-calendar-top-shadow: 3px -14px 30px 0px rgba(0, 0, 0, .2);
  --v-calendar-text-color: #7b8187;
  --v-calendar-action-color: #7b8187;
  --v-calendar-text-disabled-color: #b8b8b9;
  --v-calendar-view-button-color: #7b8187;
  --v-calendar-view-button-font-weight: 400;
  --v-calendar-view-button-font-size: 1rem;
  --v-calendar-datepicker-icon-color: #3c3c3c;
  --v-calendar-datepicker-icon-size: 1.1rem;
  --v-calendar-active-bg-color: #ff0000;
  --v-calendar-active-text-color: #fff;
  --v-calendar-range-bg-color: #edfff9;
  --v-calendar-range-text-color: #7b8187;
  --v-calendar-range-radius: 100%;
  --v-calendar-day-hover-bg-color: #eaeaeb;
  --v-calendar-day-width: 25px;
  --v-calendar-day-height: 25px;
  --v-calendar-day-font-size: 0.9rem;
  --v-calendar-day-font-weight: 400;
  --v-calendar-day-name-font-size: 0.9rem;
  --v-calendar-day-name-font-weight: 500;
  --v-calendar-day-name-color: #7b8187;
  --v-calendar-input-border: 1px solid #eaeaeb;
  --v-calendar-input-text-color: #7b8187;
  --v-calendar-input-font-size: 0.9rem;
  --v-calendar-input-font-weight: 400;
  --v-calendar-content-radius: 0px;
  --v-calendar-year-font-size: 1.1rem;
  --v-calendar-year-color: #7b8187;
  --v-calendar-year-font-weight: 400;
  --v-calendar-year-disabled-color: #b8b8b9;
  --v-calendar-year-disabled-bg-color: transparent;
  --v-calendar-year-padding: 10px;
  --v-calendar-year-border: none;
  --v-calendar-year-border-radius: none;
  --v-calendar-month-font-size: 1.1rem;
  --v-calendar-month-color: #7b8187;
  --v-calendar-month-font-weight: 400;
  --v-calendar-month-disabled-color: #b8b8b9;
  --v-calendar-month-disabled-bg-color: transparent;
  --v-calendar-month-padding: 8px;
  --v-calendar-month-border: none;
  --v-calendar-month-border-radius: none
}

.v-calendar :focus {
  outline: none
}

.v-calendar * {
  outline: none;
  font-family: inherit
}

.v-calendar {
  position: relative;
  width: 100%;
  width: max-content;
  min-width: -webkit-max-content;
  min-width: -moz-max-content;
  min-width: max-content
}

.v-calendar .content {
  background: var(--v-calendar-picker-color);
  -webkit-box-shadow: var(--v-calendar-shadow);
  box-shadow: var(--v-calendar-shadow);
  position: absolute;
  top: 56px;
  z-index: 99999
}

.v-calendar .content, .v-calendar .input-field {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}

.v-calendar .input-field {
  position: relative;
  min-width: 140px;
  font-weight: var(--v-calendar-input-font-weight)
}

.v-calendar .input-field input:disabled ~ svg {
  fill: var(--v-calendar-text-color)
}

.v-calendar .input-field.long {
  min-width: 290px
}

.v-calendar .input-field input {
  padding-left: 40px;
  padding-right: 20px;
  font-size: var(--v-calendar-input-font-size);
  min-width: inherit;
  height: 40px;
  border-radius: 6px;
  border: var(--v-calendar-input-border);
  background-color: var(--v-calendar-input-bg-color);
  color: var(--v-calendar-input-text-color);
  font-weight: inherit
}

.v-calendar .input-field input:disabled {
  background-color: var(--v-calendar-input-bg-disable-color);
  color: var(--v-calendar-input-text-disable-color);
  cursor: not-allowed
}

.v-calendar .input-field svg {
  top: 50%;
  position: absolute;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%)
}

.v-calendar .input-field svg.datepicker {
  left: 10px;
  width: var(--v-calendar-datepicker-icon-size);
  height: var(--v-calendar-datepicker-icon-size);
  fill: var(--v-calendar-datepicker-icon-color)
}

.v-calendar .calendar {
  width: max-content
}

.v-calendar .calendar.range:first-child {
  border-right: 1px solid var(--v-calendar-border-color)
}

.v-calendar .calendar:first-child:before {
  content: "";
  position: absolute;
  bottom: 100%;
  top: -20px
}

.v-calendar .calendar .selected-field {
  padding-top: 20px;
  background-color: var(--v-calendar-select-bg-color)
}

.v-calendar .calendar .selected-field .selected-date {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 10px
}

.v-calendar .calendar .selected-field .viewButton {
  border: 0;
  width: 100%;
  padding: 10px;
  color: var(--v-calendar-view-button-color);
  font-size: var(--v-calendar-view-button-font-size);
  font-weight: var(--v-calendar-view-button-font-weight);
  margin-right: 10px;
  margin-left: 10px;
  background: transparent;
  cursor: pointer
}

.v-calendar .calendar .selected-field .nextDateButton, .v-calendar .calendar .selected-field .prevDateButton {
  position: relative;
  border: 0;
  background: transparent
}

.v-calendar .calendar .selected-field .nextDateButton:after, .v-calendar .calendar .selected-field .prevDateButton:after {
  content: "";
  display: inline-block;
  text-align: left;
  cursor: pointer;
  border: 7px solid transparent
}

.v-calendar .calendar .selected-field .prevDateButton:after {
  border-right: 10px solid var(--v-calendar-action-color)
}

.v-calendar .calendar .selected-field .nextDateButton:after {
  border-left: 10px solid var(--v-calendar-action-color)
}

.v-calendar .calendar .days {
  display: grid;
  grid-template-columns:repeat(7, minmax(max-content, 1fr))
}

.v-calendar .calendar .months, .v-calendar .calendar .years {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  max-width: calc(var(--v-calendar-day-width) * 7 + 20px);
  min-height: 250px
}

.v-calendar .calendar .days-selection, .v-calendar .calendar .selected-field {
  padding-left: 20px;
  padding-right: 20px
}

.v-calendar .calendar .days-selection .days {
  padding-bottom: 20px
}

.v-calendar .calendar .days .day, .v-calendar .calendar .months .month, .v-calendar .calendar .years .year {
  background: transparent;
  border: 0;
  text-align: center;
  cursor: pointer
}

.v-calendar .calendar .months .month, .v-calendar .calendar .years .year {
  width: max-content;
  height: max-content
}

.v-calendar .calendar .months .month {
  font-size: var(--v-calendar-month-font-size);
  font-weight: var(--v-calendar-month-font-weight);
  color: var(--v-calendar-month-color);
  padding: var(--v-calendar-month-padding);
  border: var(--v-calendar-month-border);
}

.v-calendar .calendar .months .month:disabled {
  pointer-events: none;
  color: var(--v-calendar-month-disabled-color);
  background-color: var(--v-calendar-month-disabled-bg-color)
}

.v-calendar .calendar .days .day {
  padding: 0;
  margin-right: 10px;
  font-size: var(--v-calendar-day-font-size);
  font-weight: var(--v-calendar-day-font-weight);
  color: var(--v-calendar-text-color);
  width: 100%;
  text-align: left
}

.v-calendar .calendar .days .day, .v-calendar .calendar .days .day .number {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.v-calendar .calendar .days .day .number {
  width: var(--v-calendar-day-width);
  height: var(--v-calendar-day-height);
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 10px;
  font-size: inherit
}

.v-calendar .calendar .days .day.name {
  pointer-events: none;
  font-size: var(--v-calendar-day-name-font-size);
  font-weight: var(--v-calendar-day-name-font-weight);
  color: var(--v-calendar-day-name-color);
  width: auto
}

.v-calendar .calendar .days .day.selectedDate .number {
  background: var(--v-calendar-active-bg-color);
  color: var(--v-calendar-active-text-color)
}

.v-calendar .calendar .days .day.circle .number {
  border-radius: 100%
}

.v-calendar .calendar .days .day.selectedRange {
  background: var(--v-calendar-range-bg-color);
  color: var(--v-calendar-range-text-color)
}

.v-calendar .calendar:first-child .days .day.selectedDate {
  border-top-left-radius: var(--v-calendar-range-radius);
  border-bottom-left-radius: var(--v-calendar-range-radius)
}

.v-calendar .calendar:last-child .days .day.selectedDate {
  border-top-right-radius: var(--v-calendar-range-radius);
  border-bottom-right-radius: var(--v-calendar-range-radius)
}

.v-calendar .calendar .days .day.disabledDate {
  pointer-events: none;
  color: var(--v-calendar-text-disabled-color)
}

.v-calendar .calendar .days .day.disabledDate.selectedRange {
  background: var(--v-calendar-range-bg-color)
}

.v-calendar .calendar .days .day:hover .number {
  background: var(--v-calendar-day-hover-bg-color)
}

.v-calendar .calendar .years .year {
  font-size: var(--v-calendar-year-font-size);
  font-weight: var(--v-calendar-year-font-weight);
  color: var(--v-calendar-year-color);
  padding: var(--v-calendar-year-padding);
  border: var(--v-calendar-year-border);
  border-radius: var(--v-calendar-year-border-radius);
}

.v-calendar .calendar .years .year:disabled {
  pointer-events: none;
  color: var(--v-calendar-year-disabled-color);
  background-color: var(--v-calendar-year-disabled-bg-color)
}

.v-calendar.left .content {
  left: 0;
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  border-bottom-left-radius: var(--v-calendar-content-radius);
  border-bottom-right-radius: var(--v-calendar-content-radius);
  border-top-right-radius: var(--v-calendar-content-radius)
}

.v-calendar.left .calendar:first-child:before {
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--v-calendar-triangle-color) transparent;
  left: 0
}

.v-calendar.right .content {
  right: 0;
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  border-bottom-left-radius: var(--v-calendar-content-radius);
  border-bottom-right-radius: var(--v-calendar-content-radius);
  border-top-left-radius: var(--v-calendar-content-radius)
}

.v-calendar.right .calendar:first-child:before {
  right: 0;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--v-calendar-triangle-color) transparent
}

.v-calendar.top .content {
  top: 100%;
  -webkit-transform: translateY(calc(-100% - 66px));
  transform: translateY(calc(-100% - 66px));
  -webkit-box-shadow: var(--v-calendar-top-shadow);
  box-shadow: var(--v-calendar-top-shadow);
  border-top-left-radius: var(--v-calendar-content-radius);
  border-top-right-radius: var(--v-calendar-content-radius);
  border-bottom-right-radius: var(--v-calendar-content-radius)
}

.v-calendar.top .content .calendar:first-child:before {
  border-width: 5px;
  border-style: solid;
  border-color: var(--v-calendar-triangle-color) transparent transparent transparent;
  top: 100%;
  left: 0
}

.v-calendar.bottom .content {
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  border-bottom-left-radius: var(--v-calendar-content-radius);
  border-bottom-right-radius: var(--v-calendar-content-radius);
  border-top-right-radius: var(--v-calendar-content-radius)
}

.v-calendar.bottom .content .calendar:first-child:before {
  left: 0
}

.v-calendar.bottom .content .calendar:first-child:before, .v-calendar.center .calendar:first-child:before {
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--v-calendar-triangle-color) transparent
}

.v-calendar.center .calendar:first-child:before {
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%)
}

.v-calendar.center .content {
  -webkit-transform: translateY(5px) translateX(-50%);
  transform: translateY(5px) translateX(-50%);
  left: 50%;
  border-bottom-left-radius: var(--v-calendar-content-radius);
  border-bottom-right-radius: var(--v-calendar-content-radius);
  border-top-right-radius: var(--v-calendar-content-radius)
}
</style>
